import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CartIndicatorDirective } from './cart-indicator.shared.directive';
import { CartPopupDirective } from './cart-popup.shared.directive';

@NgModule({
    declarations: [
        CartIndicatorDirective,
        CartPopupDirective,
    ],
    imports: [CommonModule],
    exports: [
        CartIndicatorDirective,
        CartPopupDirective,
    ],
    providers: [],
})
export class CartDirectivesModule { }
